import { keepPreviousData, useQuery } from '@tanstack/react-query';
import adminDashboardService from '../services/adminDashboardService';
import { queryKeys } from './queryKeys';

// Analytics aggregates change slowly; cache for 5 minutes so navigating back
// to the dashboard (or remounting) doesn't refire every call at once.
const ANALYTICS_STALE_TIME = 5 * 60_000;

export function useRequestVolume(startDate, endDate, options = {}) {
  return useQuery({
    queryKey: [...queryKeys.analytics.requests, startDate, endDate],
    queryFn: () => adminDashboardService.getTotalRequests({ start_date: startDate, end_date: endDate }),
    staleTime: ANALYTICS_STALE_TIME,
    // Keep the previous range's data visible while a new date range loads.
    placeholderData: keepPreviousData,
    ...options,
  });
}

export function useHourlyRequests(startDate, endDate, options = {}) {
  return useQuery({
    queryKey: [...queryKeys.analytics.hourly, startDate, endDate],
    queryFn: () => adminDashboardService.getHourlyRequests({ start_date: startDate, end_date: endDate }),
    staleTime: ANALYTICS_STALE_TIME,
    placeholderData: keepPreviousData,
    ...options,
  });
}

export function useTopAgentsVolume(startDate, endDate, options = {}) {
  return useQuery({
    queryKey: [...queryKeys.analytics.topAgents, startDate, endDate],
    queryFn: () => adminDashboardService.getTopAgents({ start_date: startDate, end_date: endDate }),
    staleTime: ANALYTICS_STALE_TIME,
    placeholderData: keepPreviousData,
    ...options,
  });
}

export function useErrorVolume(startDate, endDate, options = {}) {
  return useQuery({
    queryKey: [...queryKeys.analytics.errors, startDate, endDate],
    queryFn: () => adminDashboardService.getTotalErrors({ start_date: startDate, end_date: endDate }),
    staleTime: ANALYTICS_STALE_TIME,
    ...options,
  });
}

export function useTotalUsers(startDate, endDate, options = {}) {
  return useQuery({
    queryKey: [...queryKeys.analytics.totalUsers, startDate, endDate],
    queryFn: () => adminDashboardService.getTotalUsers({ start_date: startDate, end_date: endDate }),
    staleTime: ANALYTICS_STALE_TIME,
    ...options,
  });
}

export function useActiveUsers(startDate, endDate, options = {}) {
  return useQuery({
    queryKey: [...queryKeys.analytics.activeUsers, startDate, endDate],
    queryFn: () => adminDashboardService.getActiveUsers({ start_date: startDate, end_date: endDate }),
    staleTime: ANALYTICS_STALE_TIME,
    ...options,
  });
}

export function usePlatforms(options = {}) {
  return useQuery({
    queryKey: queryKeys.analytics.platforms,
    queryFn: () => adminDashboardService.getPlatforms(),
    staleTime: ANALYTICS_STALE_TIME,
    ...options,
  });
}
